// src/pages/CrearCortesia.js
import React, { useState, useEffect } from "react";
import axios from "axios";

export default function CrearCortesia() {
  const [dni, setDni] = useState("");
  const [email, setEmail] = useState("");
  const [cantidad, setCantidad] = useState(1);
  const [downloadingAll, setDownloadingAll] = useState(false);
  const [formEnabled, setFormEnabled] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const [eventos, setEventos] = useState([]);
  const [idEvento, setIdEvento] = useState("");
  const [functionId, setFunctionId] = useState("");
  const [tipoPago, setTipoPago] = useState("PAID");
  const [tandaId, setTandaId] = useState("");
  // eslint-disable-next-line

  const [ticketsPrevios, setTicketsPrevios] = useState([]);
  // eslint-disable-next-line
  const [entradas, setEntradas] = useState([]);
  const [hashes, setHashes] = useState([]);

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");

  const capitalize = (str) =>
    str
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");

  // ----------------------------------------------------------
  // 1. TRAER EVENTOS
  // ----------------------------------------------------------
  useEffect(() => {
    const load = async () => {
      try {
        const loginType = localStorage.getItem("loginType");
        const res = await axios.post(
          "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod/getEventsSensoria",
          { loginType },
        );

        let lista = [];
        try {
          if (Array.isArray(res.data)) lista = res.data;
          else if (res.data?.body) lista = JSON.parse(res.data.body);
        } catch {}

        if (loginType === "1") {
          lista = lista.filter((ev) => ev.active === "1" || ev.active === "3");
        } else {
          lista = lista.filter((ev) => ev.active === "1");
        }

        lista = lista.map((ev) => ({
          ...ev,
          funciones: (ev.funciones || []).map((f) => ({
            ...f,
            id: String(f.id),
            label: f.label || `Función ${f.id}`,
          })),
        }));

        lista.sort((a, b) => new Date(a.fechaEvento) - new Date(b.fechaEvento));

        setEventos(lista);
      } catch (e) {
        console.log(e);
      }
    };
    load();
  }, []);

  // ----------------------------------------------------------
  // 2. BUSCAR TICKETS EXISTENTES
  // ----------------------------------------------------------
  const buscarTickets = async () => {
    if (!dni) return setMsg("Escribí DNI");

    setMsg("Buscando...");
    setTicketsPrevios([]);
    setFormEnabled(false);

    try {
      let rows = [];

      if (idEvento && functionId !== "ALL") {
        const res = await axios.post(
          "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod/getTicket",
          { dni },
        );
        rows = res.data || [];
      }

      setTicketsPrevios(rows);

      if (rows.length > 0) {
        const t = rows[0];
        setNombre(t.first_name || "");
        setApellido(t.last_name || "");
        setEmail(t.email || "");
      } else {
        setNombre("");
        setApellido("");
        setEmail("");
      }

      setFormEnabled(true);
      setMsg("");
    } catch (e) {
      setMsg("Error buscando tickets.");
    }
  };

  // ----------------------------------------------------------
  // 3. CREAR CORTESÍA / EFECTIVO
  // ----------------------------------------------------------
  const crearCortesia = async () => {
    if (!dni || !email || !idEvento || !functionId)
      return setMsg("Completá todos los campos");

    if (!tandaId) return setMsg("Debés elegir un tipo de ticket (tanda)");

    setLoading(true);
    setMsg("");

    try {
      const eventoSel = eventos.find((e) => e.idEvento === idEvento);
      const funcionSel = eventoSel.funciones.find(
        (f) => String(f.id) === String(functionId),
      );
      const tandaSel = eventoSel.tandas?.find((t) => t.id === tandaId);
      const precioReal = tipoPago === "-" ? Number(tandaSel?.price || 0) : 0;

      const payload = {
        modo: "individual",
        idEvento: eventoSel.idEvento,
        name: eventoSel.name,
        title: eventoSel.name,
        email,
        dni,
        nombre,
        apellido,
        functionId: funcionSel.id,
        functionName: funcionSel.label,
        horaInicioEvento: eventoSel?.horaInicioEvento || "",
        quantity: cantidad,
        price: precioReal,
        tanda: tandaSel?.label,
        tandaId: tandaSel?.id || "",
        importeTotal: tipoPago === "CORTESIA" ? "CORTESIA" : "-",
        createdBy: localStorage.getItem("dniUser") || "",
        tipoPago,
      };

      const res = await axios.post(
        "https://mocaub1h8d.execute-api.us-east-1.amazonaws.com/prod/createEntradasNavidadBatch",
        payload,
      );

      console.log("RESPUESTA BACK RAW:", res.data);

      const data =
        typeof res.data?.body === "string"
          ? JSON.parse(res.data.body)
          : res.data?.body || res.data;

      console.log("RESPUESTA BACK PARSEADA:", data);

      if (!data?.ok) {
        throw new Error(data?.error || "La Lambda respondió ok=false");
      }


    const tickets = data.tickets || data.resultados || [];

    const pdfUrls = tickets.map((t) => t.pdf_url).filter(Boolean);

    setHashes(pdfUrls);
    setEntradas(
      tickets.map((t) => ({
        ...t,
        functionId: t.functionName || t.functionId,
      })),
    );

      setMsg("✔ Tickets creados correctamente");
    } catch (e) {
      console.error("ERROR CREANDO CORTESIA:", e);
      console.error("ERROR RESPONSE:", e?.response?.data);
      setMsg(
        e?.response?.data?.error || e?.message || "Error creando cortesía",
      );
    }
    setLoading(false);
  };

  // ----------------------------------------------------------
  // 4. DESCARGAR TODOS
  // ----------------------------------------------------------
  const downloadAll = async () => {
    if (downloadingAll || hashes.length === 0) return;

    setDownloadingAll(true);

    try {
      for (let i = 0; i < hashes.length; i++) {
        const url = hashes[i];
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.download = `ticket_${i + 1}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        await new Promise((r) => setTimeout(r, 300));
      }

      setEntradas([]);
      setHashes([]);
      setTicketsPrevios([]);
      setFormEnabled(false);
      setDni("");
      setEmail("");
      setNombre("");
      setApellido("");
      setCantidad(1);
      setIdEvento("");
      setFunctionId("");
      setTandaId("");
      setMsg("✔ Tickets descargados correctamente");
    } catch (e) {
      console.error("Error descargando tickets", e);
    }

    setDownloadingAll(false);
  };

  const eventoSeleccionado = eventos.find((ev) => ev.idEvento === idEvento);

  // ----------------------------------------------------------
  // UI
  // ----------------------------------------------------------
  return (
    <div
      style={{
        padding: 20,
        color: "#fff",
        minHeight: "100vh",
        background: "#333",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2 style={{ textAlign: "center" }}>CREAR TICKET</h2>

      {/* FORM */}
      <div
        style={{
          background: "#fff",
          color: "#333",
          padding: 20,
          borderRadius: 12,
          width: "90%",
          maxWidth: 500,
          marginTop: 20,
          marginBottom: "50px",
        }}
      >
        <label>Evento + Función</label>
        <select
          value={`${idEvento}|${functionId}`}
          onChange={(e) => {
            const [evId, funcId] = e.target.value.split("|");
            setIdEvento(evId);
            setFunctionId(funcId);
          }}
          style={styles.input}
        >
          <option value="">Elegir...</option>
          {eventos.map((ev) => (
            <optgroup key={ev.idEvento} label={ev.name}>
              {ev.funciones.map((f) => (
                <option key={f.id} value={`${ev.idEvento}|${f.id}`}>
                  {ev.name} — {f.label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>

        <label>DNI invitado</label>
        <input
          type="number"
          value={dni}
          onChange={(e) => setDni(e.target.value)}
          style={styles.input}
        />
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <button onClick={buscarTickets} style={styles.btnSecondary}>
            BUSCAR TICKETS EXISTENTES
          </button>
        </div>

        {ticketsPrevios.length > 0 && (
          <div
            style={{
              marginTop: 20,
              padding: 15,
              background: "#222",
              borderRadius: 10,
              color: "#fff",
              marginBottom: 20,
            }}
          >
            <h3>Tickets existentes</h3>
            {ticketsPrevios.map((t, i) => (
              <div
                key={i}
                style={{
                  padding: 10,
                  background: "#444",
                  borderRadius: 8,
                  marginBottom: 10,
                }}
              >
                <p>
                  <b>Función:</b> {t.functionId}
                </p>
                <p>
                  <b>Tanda:</b> {t.tanda}
                </p>
                <p>
                  <b>Tipo pago:</b> {t.tipoPago || "CORTESIA"}
                </p>
                <p>
                  <b>Nª Ticket:</b> {t.numeroTicket} de {t.cantidadTotal}
                </p>
              </div>
            ))}
          </div>
        )}

        <label>Nombre invitado</label>
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(capitalize(e.target.value))}
          style={styles.input}
          disabled={!formEnabled}
        />

        <label>Apellido invitado</label>
        <input
          type="text"
          value={apellido}
          onChange={(e) => setApellido(capitalize(e.target.value))}
          style={styles.input}
          disabled={!formEnabled}
        />

        <label>Email invitado</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          disabled={!formEnabled}
        />

        <label>Cantidad Tickets</label>
        <input
          type="number"
          min="1"
          value={cantidad}
          onChange={(e) => setCantidad(e.target.value)}
          style={styles.input}
          disabled={!formEnabled}
        />

        <label>Tipo de pago</label>
        <select
          value={tipoPago}
          onChange={(e) => setTipoPago(e.target.value)}
          style={styles.input}
          disabled={!formEnabled}
        >
          <option value="-">Pago</option>
          <option value="CORTESIA">Cortesía</option>
        </select>

        {idEvento && (
          <>
            <label>Seleccionar Tipo Ticket</label>
            <select
              value={tandaId}
              onChange={(e) => setTandaId(e.target.value)}
              style={styles.input}
              disabled={!formEnabled}
            >
              <option value="">Elegir tanda...</option>
              {eventos
                .find((ev) => ev.idEvento === idEvento)
                ?.tandas?.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.label} — ${t.price}
                  </option>
                ))}
            </select>
          </>
        )}

        <button
          onClick={() => setShowConfirmPopup(true)}
          style={styles.btnPrimary}
          disabled={!formEnabled}
        >
          GENERAR TICKETS
        </button>
      </div>

      {/* MENSAJES */}
      {msg && <p style={{ marginTop: 15, marginBottom: "30px" }}>{msg}</p>}
      {loading && <p style={{ marginTop: 15 }}>Generando...</p>}

      {/* BOTÓN DESCARGAR TODOS */}
      {hashes.length > 0 && (
        <div style={{ width: "90%", maxWidth: 500, marginBottom: 20 }}>
          <button
            onClick={downloadAll}
            disabled={downloadingAll}
            style={{
              background: downloadingAll ? "#999" : "#dfa66b",
              color: "#333",
              padding: "14px",
              width: "100%",
              borderRadius: 50,
              fontWeight: "bold",
              cursor: downloadingAll ? "not-allowed" : "pointer",
              fontSize: "1.1em",
            }}
          >
            {downloadingAll ? "DESCARGANDO..." : "DESCARGAR TODOS LOS TICKETS"}
          </button>
        </div>
      )}

      {/* LISTA DE LINKS */}
      {hashes.length > 0 && (
        <div
          style={{
            background: "#fff",
            color: "#333",
            padding: 20,
            borderRadius: 12,
            width: "90%",
            maxWidth: 500,
            marginBottom: 40,
          }}
        >
          <h3 style={{ marginBottom: 12 }}>Tickets generados</h3>
          {hashes.map((url, i) => (
            <div
              key={i}
              style={{
                padding: "12px 0",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#dfa66b",
                  fontWeight: "bold",
                  fontSize: "1em",
                  textDecoration: "none",
                }}
              >
                Ticket {i + 1}
              </a>
            </div>
          ))}
        </div>
      )}

      {/* POPUP CONFIRMACIÓN */}
      {showConfirmPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#e3dac9",
              color: "#11200d",
              padding: 25,
              borderRadius: 16,
              width: "90%",
              maxWidth: 380,
              textAlign: "center",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
          >
            <h3 style={{ marginBottom: 15 }}>⚠️ Confirmar generación</h3>
            <p>
              <b>
                {nombre} {apellido}
              </b>
            </p>
            <p>
              DNI: <b>{dni}</b>
            </p>
            <hr style={{ margin: "15px 0" }} />
            <p>
              <b>Evento:</b> {eventoSeleccionado?.name}
            </p>
            <p>
              <b>Función:</b>{" "}
              {
                eventoSeleccionado?.funciones?.find(
                  (f) => String(f.id) === String(functionId),
                )?.label
              }
            </p>
            <p>
              <b>Tanda:</b>{" "}
              {
                eventoSeleccionado?.tandas?.find(
                  (t) => String(t.id) === String(tandaId),
                )?.label
              }
            </p>
            <p>
              <b>Cantidad:</b> {cantidad}
            </p>
            <p>
              <b>Tipo de pago:</b> {tipoPago}
            </p>

            <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
              <button
                onClick={() => setShowConfirmPopup(false)}
                style={{
                  flex: 1,
                  background: "#999",
                  color: "#fff",
                  border: "none",
                  padding: 10,
                  borderRadius: 50,
                  cursor: "pointer",
                }}
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  setShowConfirmPopup(false);
                  crearCortesia();
                }}
                style={{
                  flex: 1,
                  background: "#11200d",
                  color: "#e3dac9",
                  border: "none",
                  padding: 10,
                  borderRadius: 50,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  input: {
    width: "100%",
    padding: 10,
    borderRadius: 10,
    border: "1px solid #ccc",
    marginBottom: 12,
  },
  btnPrimary: {
    background: "#dfa66b",
    border: "none",
    color: "#333",
    padding: 12,
    width: "100%",
    borderRadius: 50,
    fontWeight: "bold",
    marginTop: 10,
    cursor: "pointer",
    boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.25)",
  },
  btnSecondary: {
    background: "#dfa66b",
    border: "none",
    color: "#000",
    padding: 10,
    fontWeight: "bold",
    width: "300px",
    borderRadius: 50,
    marginTop: 10,
    marginBottom: "20px",
    cursor: "pointer",
    boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.25)",
  },
};
